<template>
    <div class="boxContainer">
        <div class="box">
            <h1>DOMY</h1>
            <div class="icon" @click="updateSearchBox(18439)">
                <div class="icon">
                    <div class="offerCounter">{{ summary.domy }}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 402 402" xml:space="preserve">
                    <path
                        d="M65,289.25h8.667h79h8.667c4.418,0,8-3.582,8-8c0-4.418-3.582-8-8-8h-0.667V184.5c0-4.418-3.582-8-8-8h-79 c-4.418,0-8,3.582-8,8v88.75H65c-4.418,0-8,3.582-8,8C57,285.668,60.582,289.25,65,289.25z M144.667,192.5v32.375h-63V192.5 H144.667z M81.667,240.875h63v32.375h-63V240.875z"/>
                        <path
                            d="M231.32,275.596c-1.49-1.49-3.55-2.35-5.65-2.35c-2.11,0-4.17,0.86-5.66,2.35c-1.49,1.49-2.34,3.55-2.34,5.65 c0,2.11,0.85,4.17,2.34,5.66c1.49,1.49,3.55,2.34,5.66,2.34c2.1,0,4.16-0.85,5.65-2.34c1.49-1.49,2.35-3.55,2.35-5.66 C233.67,279.147,232.81,277.087,231.32,275.596z"/>
                        <path
                            d="M394,369.167h-9V157.994l4.42,2.212c1.13,0.565,2.356,0.846,3.58,0.846c1.462,0,2.921-0.401,4.205-1.194 c2.359-1.458,3.795-4.033,3.795-6.806v-32.135c0-3.029-1.711-5.799-4.42-7.154L360.667,95.79V32.75c0-4.418-3.582-8-8-8H297.25 c-4.418,0-8,3.582-8,8v27.301l-84.67-42.372c-2.253-1.128-4.907-1.128-7.16,0l-192,96.083C2.711,115.118,1,117.887,1,120.917 v32.135c0,2.773,1.436,5.348,3.795,6.806c2.359,1.458,5.305,1.589,7.785,0.349l4.42-2.212v211.173H8c-4.418,0-8,3.582-8,8 s3.582,8,8,8h386c4.418,0,8-3.582,8-8S398.418,369.167,394,369.167z M209,192.5h88v176.667h-88V192.5z M313,320.75h56v48.417h-56 V320.75z M305.25,40.75h39.417v47.033L305.25,68.058V40.75z M17,125.859l184-92.08l184,92.08v14.243L204.58,49.814 c-2.253-1.128-4.907-1.128-7.16,0L17,140.102V125.859z M201,65.914l168,84.073V304.75h-56V184.5c0-4.418-3.582-8-8-8H201 c-4.418,0-8,3.582-8,8v120.25H33V149.986L201,65.914z M33,320.75h160v48.417H33V320.75z"/>
                </svg>
                </div>
            </div>
        </div>
        <div class="box">
            <h1>MIESZKANIA</h1>
            <div class="icon" @click="updateSearchBox(10144)">
                <div class="icon">
                    <div class="offerCounter">{{ summary.mieszkania }}</div>
                    <svg width="64" height="64" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 441.489 441.489"
                        xml:space="preserve">
                    <path
                        d="M116.745,321.864H76.62c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C124.745,325.446,121.163,321.864,116.745,321.864z M108.745,337.864v15.813H84.62v-15.813H108.745z M84.62,385.489v-15.813h24.125 v15.813H84.62z"/>
                        <path
                            d="M116.745,226.197H76.62c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C124.745,229.779,121.163,226.197,116.745,226.197z M108.745,242.197v15.813H84.62v-15.813H108.745z M84.62,289.822V274.01h24.125 v15.813H84.62z"/>
                        <path
                            d="M188.62,321.864h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C196.62,325.446,193.038,321.864,188.62,321.864z M180.62,337.864v15.813h-24.125v-15.813H180.62z M156.495,385.489v-15.813h24.125 v15.813H156.495z"/>
                        <path
                            d="M188.62,226.197h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C196.62,229.779,193.038,226.197,188.62,226.197z M180.62,242.197v15.813h-24.125v-15.813H180.62z M156.495,289.822V274.01h24.125 v15.813H156.495z"/>
                        <path
                            d="M324.807,74.164h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8V82.164 C332.807,77.746,329.225,74.164,324.807,74.164z M316.807,90.164v15.813h-24.125V90.164H316.807z M292.682,137.789v-15.813h24.125 v15.813H292.682z"/>
                        <path
                            d="M413.078,425.489h-8.333V210.544c0-0.027-0.004-0.052-0.004-0.079c0.048,0.001,0.096,0.011,0.144,0.011 c2.472,0,4.908-1.141,6.475-3.292c2.601-3.572,1.813-8.576-1.759-11.176l-44.855-32.656V59.778 c0.109,0.004,0.217,0.025,0.326,0.025c2.472,0,4.908-1.141,6.475-3.292c2.601-3.571,1.813-8.575-1.759-11.176L309.621,1.533 c-2.806-2.042-6.606-2.043-9.412-0.004l-60.167,43.728c-3.574,2.598-4.366,7.601-1.769,11.175c1.634,2.249,4.221,3.393,6.805,3.288 v17.002l-19.125-14.412c-2.81-2.118-6.673-2.15-9.518-0.083l-61.524,44.714l-21.316-15.518c-2.804-2.042-6.605-2.044-9.412-0.004 l-99.808,72.538c-2.071,1.505-3.297,3.911-3.297,6.471v33.169c0,3.009,1.688,5.763,4.369,7.128 c2.681,1.365,5.901,1.112,8.334-0.657l2.962-2.153v217.571h-8.333c-4.418,0-8,3.582-8,8s3.582,8,8,8h384.667c4.418,0,8-3.582,8-8 S417.496,425.489,413.078,425.489z M332.953,394.256c1.672-0.258,3.249-1.034,4.452-2.237c1.489-1.49,2.34-3.55,2.34-5.65 c0-2.11-0.851-4.17-2.34-5.66c-1.203-1.203-2.78-1.979-4.452-2.238v-40.607h23.625v87.625h-23.625V394.256z M364.578,321.864 h-39.625c-4.418,0-8,3.582-8,8v95.625h-88.208V211.72c1.222-0.007,2.449-0.292,3.579-0.867c0.219-0.112,0.421-0.247,0.627-0.376 h155.797c0,0.023-0.003,0.045-0.003,0.068v214.945h-16.167v-95.625C372.578,325.446,368.996,321.864,364.578,321.864z M261.078,58.143h87.667v111.667h-87.667V58.143z M304.908,17.893l33.308,24.25h-66.675L304.908,17.893z M221.052,78.652 l24.025,18.104v81.053c0,4.418,3.582,8,8,8h103.667c2.8,0,5.26-1.441,6.689-3.619l16.875,12.286H236.695v-23.922 c0-2.558-1.224-4.962-3.291-6.468l-64.896-47.246L221.052,78.652z M37.08,174.505l91.804-66.721l91.812,66.841v13.378 l-87.099-63.41c-1.403-1.022-3.056-1.532-4.708-1.532c-1.65,0-3.301,0.51-4.703,1.529L37.08,187.895V174.505z M52.745,196.289 l76.139-55.336l83.861,61.053v223.482h-160V196.289z"/>
                        <path
                            d="M293.203,226.197h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C301.203,229.779,297.621,226.197,293.203,226.197z M285.203,242.197v15.813h-24.125v-15.813H285.203z M261.078,289.822V274.01 h24.125v15.813H261.078z"/>
                        <path
                            d="M293.203,321.864h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125c4.418,0,8-3.582,8-8v-63.625 C301.203,325.446,297.621,321.864,293.203,321.864z M285.203,337.864v15.813h-24.125v-15.813H285.203z M261.078,385.489v-15.813 h24.125v15.813H261.078z"/>
                        <path
                            d="M373.078,234.197c0-4.418-3.582-8-8-8h-40.125c-4.418,0-8,3.582-8,8v63.625c0,4.418,3.582,8,8,8h40.125 c4.418,0,8-3.582,8-8V234.197z M357.078,242.197v15.813h-24.125v-15.813H357.078z M332.953,289.822V274.01h24.125v15.813H332.953z"/>
                </svg>
                </div>
            </div>
        </div>
        <div class="box">
            <h1>DZIAŁKI</h1>
            <div class="icon" @click="updateSearchBox(24)">
                <div class="icon">
                    <div class="offerCounter">{{ summary.dzialki }}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512.003 512.003" xml:space="preserve">
                    <path
                        d="M368.22,88.176c-21.822,0-39.577,17.755-39.577,39.577s17.755,39.577,39.577,39.577s39.577-17.755,39.577-39.577 S390.042,88.176,368.22,88.176z M368.22,152.3c-13.536,0-24.548-11.012-24.548-24.548c0-13.535,11.011-24.548,24.548-24.548 c13.536,0,24.548,11.012,24.548,24.548C392.768,141.288,381.756,152.3,368.22,152.3z"/>
                        <path
                            d="M223.939,360.706c-26.242,0-47.593,21.351-47.593,47.593c0,32.794,40.552,73.723,42.278,75.45 c1.411,1.41,3.321,2.201,5.314,2.201s3.904-0.792,5.314-2.201c1.725-1.725,42.278-42.656,42.278-75.45 C271.532,382.056,250.181,360.706,223.939,360.706z M223.939,467.478c-12.366-13.763-32.563-40.224-32.563-59.18 c0-17.955,14.607-32.563,32.563-32.563s32.563,14.608,32.563,32.563C256.503,427.255,236.304,453.718,223.939,467.478z"/>
                        <path
                            d="M223.939,385.754c-12.43,0-22.544,10.113-22.544,22.544c0,12.431,10.114,22.544,22.544,22.544 s22.544-10.113,22.544-22.544C246.483,395.867,236.369,385.754,223.939,385.754z M223.939,415.813 c-4.144,0-7.515-3.371-7.515-7.515s3.371-7.515,7.515-7.515c4.144,0,7.515,3.371,7.515,7.515S228.083,415.813,223.939,415.813z"/>
                        <path
                            d="M322.955,0.571c-3.839-1.583-8.231,0.244-9.813,4.08l-36.459,88.352L142.627,57.548V7.519c0-4.15-3.364-7.515-7.515-7.515 s-7.515,3.365-7.515,7.515v55.816c0,3.41,2.296,6.392,5.593,7.264l146.007,38.617c0.642,0.169,1.286,0.25,1.924,0.25 c2.98,0,5.761-1.781,6.945-4.649l38.968-94.433C328.617,6.548,326.79,2.154,322.955,0.571z"/>
                        <path
                            d="M96.956,299.397L9.44,276.249c-4.009-1.061-8.124,1.332-9.187,5.343c-1.061,4.013,1.332,8.125,5.343,9.186l81.923,21.668 v52.768c0,4.15,3.364,7.515,7.515,7.515s7.515-3.365,7.515-7.515v-58.553C102.549,303.252,100.253,300.269,96.956,299.397z"/>
                        <path
                            d="M95.034,0.004c-4.151,0-7.515,3.365-7.515,7.515v35.454L9.44,22.322c-4.009-1.062-8.124,1.332-9.187,5.343 c-1.061,4.013,1.332,8.125,5.343,9.186l87.516,23.147c0.634,0.167,1.279,0.25,1.922,0.25c1.64,0,3.256-0.538,4.584-1.56 c1.849-1.423,2.931-3.623,2.931-5.955V7.519C102.549,3.369,99.184,0.004,95.034,0.004z"/>
                        <path
                            d="M95.034,393.77c-4.151,0-7.515,3.365-7.515,7.515v103.201c0,4.15,3.364,7.515,7.515,7.515s7.515-3.365,7.515-7.515 V401.285C102.549,397.135,99.184,393.77,95.034,393.77z"/>
                        <path
                            d="M96.956,86.925L9.44,63.778c-4.009-1.062-8.124,1.332-9.187,5.343c-1.061,4.012,1.332,8.125,5.343,9.186L87.52,99.976 v155.469L9.44,234.794c-4.009-1.062-8.124,1.332-9.187,5.343c-1.061,4.013,1.332,8.125,5.343,9.186l87.516,23.147 c0.634,0.167,1.279,0.25,1.922,0.25c1.64,0,3.256-0.538,4.584-1.56c1.849-1.423,2.931-3.622,2.931-5.955V94.189 C102.549,90.78,100.253,87.797,96.956,86.925z"/>
                        <path
                            d="M507.352,68.478c-3.839-1.585-8.231,0.243-9.813,4.08l-29.34,71.1l-28.881-7.639c0.348-2.786,0.542-5.548,0.542-8.268 c0-39.502-32.138-71.639-71.639-71.639c-6.074,0-11.971,0.766-17.607,2.195l19.776-47.924c1.583-3.836-0.244-8.23-4.079-9.813 c-3.84-1.583-8.231,0.243-9.813,4.08L330.93,66.607c-20.583,12.601-34.349,35.293-34.349,61.143c0,4.018,0.404,8.122,1.143,12.274 L137.034,97.526c-2.253-0.595-4.658-0.112-6.506,1.311c-1.849,1.423-2.931,3.622-2.931,5.955v38.069 c-9.445,8.703-15.376,21.166-15.376,34.991c0,13.662,7.039,28.734,15.376,41.796v56.158c0,3.41,2.296,6.392,5.593,7.264 l258.473,68.365c0.642,0.169,1.286,0.25,1.924,0.25c2.98,0,5.761-1.781,6.945-4.649l63.626-154.187 c0.827-2.003,0.748-4.264-0.214-6.205c-0.963-1.941-2.716-3.372-4.81-3.926l-32.643-8.634c3.932-7.683,7.272-15.55,9.633-23.362 l34.592,9.149c0.642,0.169,1.286,0.25,1.924,0.25c2.98,0,5.761-1.781,6.945-4.649l31.849-77.181 C513.015,74.455,511.188,70.061,507.352,68.478z M368.22,71.142c31.215,0,56.61,25.395,56.61,56.61 c0,36.579-41.6,85.015-56.61,101.301c-15.01-16.285-56.61-64.722-56.61-101.301C311.61,96.538,337.005,71.142,368.22,71.142z M127.251,177.85c0-17.955,14.607-32.563,32.563-32.563c17.956,0,32.563,14.608,32.563,32.563 c0,18.957-20.198,45.419-32.563,59.18C147.448,223.267,127.251,196.806,127.251,177.85z M446.99,195.051l-57.841,140.172 L142.627,270.02v-29.937c6.332,7.631,11.294,12.638,11.874,13.218c1.41,1.41,3.32,2.201,5.314,2.201s3.904-0.792,5.314-2.201 c1.726-1.726,42.278-42.656,42.278-75.45c0-26.242-21.351-47.593-47.593-47.593c-6.06,0-11.852,1.15-17.187,3.225v-18.933 l159.709,42.241c15.718,43.25,58.364,86.286,60.569,88.492c1.41,1.41,3.32,2.201,5.314,2.201c1.994,0,3.904-0.792,5.314-2.201 c1.671-1.671,26.555-26.783,45.355-57.665L446.99,195.051z"/>
                        <path
                            d="M506.407,407.693l-87.233-23.072c-3.644-0.963-7.431,0.918-8.868,4.399l-46.465,112.6 c-1.583,3.836,0.244,8.23,4.079,9.813c0.939,0.387,1.909,0.57,2.864,0.57c2.952,0,5.753-1.751,6.95-4.65l43.956-106.52 l80.874,21.391c4.014,1.065,8.125-1.332,9.187-5.343C512.811,412.867,510.418,408.754,506.407,407.693z"/>
                        <path
                            d="M506.407,366.236l-63.511-16.798l60.351-146.251c1.583-3.836-0.243-8.23-4.079-9.813c-3.838-1.583-8.231,0.243-9.813,4.08 l-63.627,154.187c-0.827,2.003-0.748,4.264,0.214,6.205c0.963,1.941,2.716,3.372,4.81,3.926l71.81,18.993 c0.644,0.17,1.29,0.252,1.927,0.252c3.326,0,6.368-2.227,7.26-5.595C512.811,371.412,510.418,367.299,506.407,366.236z"/>
                        <path
                            d="M384.894,378.208c-0.963-1.941-2.716-3.372-4.81-3.926l-243.05-64.285c-2.253-0.595-4.658-0.111-6.506,1.311 c-1.849,1.423-2.931,3.622-2.931,5.955v187.223c0,4.15,3.364,7.515,7.515,7.515c4.151,0,7.515-3.365,7.515-7.515V327.022 l225.314,59.594l-47.456,115.003c-1.583,3.836,0.243,8.23,4.079,9.813c0.939,0.387,1.909,0.57,2.864,0.57 c2.952,0,5.753-1.751,6.95-4.65l50.732-122.939C385.935,382.411,385.856,380.149,384.894,378.208z"/>
                        <path
                            d="M159.814,155.306c-12.43,0-22.544,10.113-22.544,22.544c0,12.431,10.114,22.544,22.544,22.544 c12.43,0,22.544-10.113,22.544-22.544C182.358,165.419,172.245,155.306,159.814,155.306z M159.814,185.365 c-4.144,0-7.515-3.371-7.515-7.515c0-4.144,3.371-7.515,7.515-7.515c4.144,0,7.515,3.371,7.515,7.515 C167.329,181.994,163.958,185.365,159.814,185.365z"/>
                </svg>
                </div>
            </div>
        </div>
        <div class="box">
            <h1>LOKALE</h1>
            <div class="icon" @click="updateSearchBox(4160)">
                <div class="offerCounter">{{ summary.lokale }}</div>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 415.5 415.5" xml:space="preserve">
                    <path
                        d="M407.5,391.5h-23.917V182.489c13.87-3.503,24.167-16.083,24.167-31.027v-15.604c0.006-0.132,0.02-0.263,0.02-0.396 c0-1.716-0.54-3.305-1.459-4.608l-22.727-37.304V40.022c0-4.418-3.582-8-8-8h-24.84C347.19,18.225,334.642,8,319.75,8H96.167 C81.285,8,68.743,18.211,65.18,32.022H39.917c-4.418,0-8,3.582-8,8v53.528L8.918,131.3c-0.482,0.792-0.799,1.65-0.982,2.53 c-0.01,0.048-0.022,0.096-0.031,0.144c-0.037,0.195-0.067,0.391-0.09,0.588c-0.019,0.156-0.03,0.314-0.039,0.473 c-0.007,0.127-0.018,0.254-0.019,0.381c-0.001,0.039-0.006,0.077-0.006,0.116v15.931c0,14.943,10.297,27.523,24.167,31.027V391.5H8 c-4.418,0-8,3.582-8,8s3.582,8,8,8h239h96.75h63.75c4.418,0,8-3.582,8-8S411.918,391.5,407.5,391.5z M391.75,151.462 c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32V151.462z M343.75,151.462c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32 V151.462z M295.75,151.462c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32V151.462z M247.75,151.462c0,8.822-7.178,16-16,16 s-16-7.178-16-16v-7.931h32V151.462z M199.75,151.462c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32V151.462z M151.75,151.462 c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32V151.462z M103.75,151.462c0,8.822-7.178,16-16,16s-16-7.178-16-16v-7.931h32 V151.462z M111.899,103.796l-6.165,23.667H76.511l11.286-23.667H111.899z M328.364,103.796l11.286,23.667h-29.223l-6.165-23.667 H328.364z M287.729,103.796l6.165,23.667h-30.305l-1.759-23.667H287.729z M245.786,103.796l1.759,23.667h-31.461v-23.667H245.786z M200.083,127.462h-31.467l1.759-23.667h29.708V127.462z M152.573,127.462h-30.305l6.165-23.667h25.898L152.573,127.462z M357.376,127.462l-11.286-23.667h25l14.418,23.667H357.376z M96.167,24H319.75c8.823,0,16,7.178,16,16.045c0,8.822-7.178,16-16,16 H96.167c-8.822,0-16-7.178-16-16.045C80.167,31.178,87.344,24,96.167,24z M65.173,48.022c3.553,13.798,16.102,24.023,30.993,24.023 H319.75c14.882,0,27.424-10.211,30.987-24.023h16.847v39.773H47.917V48.022H65.173z M44.41,103.796h25.662l-11.286,23.667H29.992 L44.41,103.796z M23.75,151.462v-7.931h32v7.931c0,8.822-7.178,16-16,16S23.75,160.285,23.75,151.462z M47.917,182.402 c6.22-1.643,11.699-5.118,15.833-9.808c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868 c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868 c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868 c5.868,6.657,14.449,10.868,24,10.868s18.132-4.211,24-10.868c4.134,4.69,9.614,8.165,15.833,9.808V391.5H351.75V215.875 c0-4.418-3.582-8-8-8H247c-4.418,0-8,3.582-8,8V391.5H47.917V182.402z M255,391.5V223.875h80.75V391.5H255z"/>
                    <path
                        d="M215.5,207.875H71.833c-4.418,0-8,3.582-8,8v127.958c0,4.418,3.582,8,8,8H215.5c4.418,0,8-3.582,8-8V215.875 C223.5,211.457,219.918,207.875,215.5,207.875z M207.5,335.833H79.833V223.875H207.5V335.833z"/>
                    <path
                        d="M271.83,295.835c-2.1,0-4.16,0.85-5.65,2.34c-1.49,1.49-2.35,3.55-2.35,5.66c0,2.1,0.86,4.17,2.35,5.65 c1.48,1.49,3.55,2.35,5.65,2.35c2.11,0,4.17-0.86,5.66-2.35c1.49-1.48,2.34-3.55,2.34-5.65c0-2.11-0.85-4.17-2.34-5.66 C276,296.685,273.94,295.835,271.83,295.835z"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>

import { useState} from "@/state";

export default {
    name: "HomeFourBox",
    data () {
        return {
            summary: false,
            state: useState()
        };
    },
    methods: {
        updateSearchBox (obiekt) {
            this.state.rodzaj = obiekt;
            this.$router.replace('/search/list/1');
        }
    },
    async mounted () {
        try {
            let response = await fetch(process.env.VUE_APP_XHR, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        mode: 'list',
                        type: 'summary',
                        page: this.$route.params.page
                    })
                }
            )
            this.summary = await response.json();
        } catch (err) {
            console.log(err)
        }
    }
}
</script>

<style lang="scss" scoped>
.boxContainer {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    top: -80px;
}

.box {
    width: 250px;
    height: 300px;
    background: #eeeeee;
    border: solid 1px #cccccc;
    transition: all 300ms;
    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;

    &:hover {
        box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
        z-index: 10;
    }

    h1 {
        font: 32px/96px 'Google Sans';
        display: block;
        color: #ff1111;
        text-align: center;
        border-bottom: solid 2px #ff1111;
        margin: 0;
    }

    div.icon {
        margin: 40px auto;
        margin-top: 60px;
        width: 64px;
        height: 64px;
        position: relative;
        cursor: pointer;

        &:before {
            content: "";
            width: 128px;
            height: 128px;
            border-radius: 64px;
            background-color: rgba(#000, .2);
            display: block;
            position: absolute;
            top: -32px;
            left: -32px;
        }

        .offerCounter {
            position: absolute;
            top: -40px;
            right: -40px;
            border-radius: 24px;
            width: 48px;
            height: 48px;
            background-color: #333333;
            color: #ffffff;
            text-align: center;
            font: 16px/48px 'Google Sans';
        }
    }
}

@media all and (max-width: 800px) {
    .boxContainer {
        top: 0;
    }
    .box {
        height: 160px;
        border: solid 1px #cccccc;

        h1 {
            display: none;
        }

        div.icon {
            margin: auto auto;
            margin-top: 50px;
        }
    }
}
@media all and (max-width: 480px) {

    .box {
        height: 160px;
        border: solid 1px #cccccc;

        h1 {
            display: none;
        }

        div.icon {
            margin: auto auto;
            margin-top: 50px;
            &:before {
                content: none;
            }

            > .offerCounter {
                position: absolute;
                top: -10px;
                right: -10px;
                border-radius: 24px;
                width: 48px;
                height: 48px;
                background-color: #333333;
                color: #ffffff;
                text-align: center;
                font: 16px/48px 'Google Sans';
            }
        }
    }
}

</style>